import React from "react"

import { FEATURE_FLAGS, FeatureFlag } from "@/feature-flags"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@coval/ui"

import { AudioFormatFields } from "./AudioFormatFields"
import { DtmfFormatFields } from "./DtmfFormatFields"
import { HandshakeFields } from "./HandshakeFields"
import { MediaFormatFields } from "./MediaFormatFields"
import { PlaybackMarkerFields } from "./PlaybackMarkerFields"
import { SampleRateFields } from "./SampleRateFields"
import { SpeechActivityFields } from "./SpeechActivityFields"
import type { WebSocketFieldProps } from "./types"

interface AdvancedConfigSectionProps extends WebSocketFieldProps {
  isHttpFirst: boolean
}

export const AdvancedConfigSection: React.FC<AdvancedConfigSectionProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
  isHttpFirst,
}) => {
  return (
    <Accordion type="single" collapsible aria-label="Advanced Configuration">
      <AccordionItem value="advanced-config">
        <AccordionTrigger>
          <div className="flex flex-col items-start gap-0.5 text-left">
            <span>Advanced Configuration</span>
            <span className="text-xs text-coval-text-muted font-normal">
              Sample rates, handshake, and audio/media/DTMF format settings
            </span>
          </div>
        </AccordionTrigger>
        <AccordionContent>
          <div className="space-y-8">
            <SampleRateFields
              metadata={metadata}
              onMetadataUpdate={onMetadataUpdate}
              disabled={disabled}
            />
            <HandshakeFields
              metadata={metadata}
              onMetadataUpdate={onMetadataUpdate}
              disabled={disabled}
              isHttpFirst={isHttpFirst}
            />
            <AudioFormatFields
              metadata={metadata}
              onMetadataUpdate={onMetadataUpdate}
              disabled={disabled}
            />
            <MediaFormatFields
              metadata={metadata}
              onMetadataUpdate={onMetadataUpdate}
              disabled={disabled}
            />
            <DtmfFormatFields
              metadata={metadata}
              onMetadataUpdate={onMetadataUpdate}
              disabled={disabled}
            />
            <FeatureFlag flagName={FEATURE_FLAGS.PLAYBACK_MARKERS}>
              <div className="space-y-4">
                <h4 className="text-sm font-medium text-coval-text">Markers</h4>
                <PlaybackMarkerFields
                  metadata={metadata}
                  onMetadataUpdate={onMetadataUpdate}
                  disabled={disabled}
                />
                <SpeechActivityFields
                  metadata={metadata}
                  onMetadataUpdate={onMetadataUpdate}
                  disabled={disabled}
                />
              </div>
            </FeatureFlag>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
